import InitScript from "./static/script"

import "./static/css/bulma.css"
import "./static/css/kit.css"
import "./static/css/app.css"

export const onClientEntry = () => {
    InitScript()
}
